import React, { ReactElement } from 'react';

import { WEB_APP_SIGNUP_URL } from '../../../../../globals';
import MaxWidth from '../../../../shared/MaxWidth';
import * as S from './Hero.styles';

export const Hero = (): ReactElement => {
  const handleClickCta = () => {
    window.location.href = WEB_APP_SIGNUP_URL;
  };

  return (
    <S.Wrapper>
      <MaxWidth>
        <S.Content>
          <S.TextBox>
            <S.Caption>Three steps to beat procrastination.</S.Caption>
            <S.DescriptionContainer>
              <S.DescriptionImage
                alt=""
                src="https://cdn.brain.fm/images/procrastination/hero.webp"
              />
              <S.DescriptionMobileImage
                alt=""
                src="https://cdn.brain.fm/images/procrastination/procrastination-hero-mobile.webp"
              />
            </S.DescriptionContainer>
            <S.CtaWrapper>
              <S.ButtonLink onClick={handleClickCta}>
                <span>LISTEN FOR FREE</span>
                <img alt="chevron right" src="https://cdn.brain.fm/icons/chevron-right.svg" />
              </S.ButtonLink>
            </S.CtaWrapper>
          </S.TextBox>
        </S.Content>
      </MaxWidth>
      <S.ImageWrapper>
        <S.CornerImage
          alt=""
          src="https://cdn.brain.fm/images/procrastination/bg_corner_blue.webp"
        />
        <S.Image alt="" src="https://cdn.brain.fm/images/procrastination/aura.webp" />
      </S.ImageWrapper>
    </S.Wrapper>
  );
};
